// extracted by mini-css-extract-plugin
module.exports = {"footerStyle":"Footer_footerStyle__wMtu-","footerSpace":"Footer_footerSpace__2pG5p","ButtonHelp":"Footer_ButtonHelp__3oKEH","tooltiptext":"Footer_tooltiptext__78hQY"};